import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import english from "../locales/language_en.json";
import arabic from "../locales/language_ar.json";
import { CONSTANT } from "../constants/constants";
import { properties } from "../constants/properties";

function getLiferayLangauageChoice() {
  try {
    const langauageId = properties.languageId;
    return langauageId.split("_")[0];
  } catch (error) {
    console.warn("Not able to find Lifery Langauage settings");
    return CONSTANT.DEFAULT_LANGUAGE;
  }
}

i18next.use(initReactI18next).init({
  lng: getLiferayLangauageChoice(),
  fallbackLng: CONSTANT.DEFAULT_LANGUAGE,
  resources: {
    en: english,
    ar: arabic,
  },
  react: {
    useSuspense: false,
  },
});

export default i18next;
